var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_945_942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9541 24.5455H23.1815C20.1739 24.5455 17.727 22.0986 17.727 19.0911C17.727 16.0835 20.1739 13.6366 23.1815 13.6366H27.9541C28.0437 13.6367 28.1324 13.6191 28.2151 13.5848C28.2979 13.5506 28.3731 13.5004 28.4364 13.4371C28.4997 13.3737 28.5499 13.2985 28.5842 13.2158C28.6184 13.133 28.636 13.0444 28.636 12.9548V10.9094C28.636 9.47963 27.527 8.31687 26.1258 8.20412L22.2101 1.36474C21.8472 0.732193 21.2613 0.280091 20.5601 0.0923594C19.8623 -0.0940935 19.1326 0.00383102 18.5081 0.367341L5.08479 8.18213H2.72725C1.22316 8.18213 0 9.40522 0 10.9094V27.2727C0 28.7768 1.2231 30 2.72725 30H25.9087C27.4128 30 28.636 28.7769 28.636 27.2727V25.2273C28.636 25.1378 28.6184 25.0491 28.5842 24.9663C28.5499 24.8836 28.4997 24.8084 28.4364 24.7451C28.3731 24.6817 28.2979 24.6315 28.2151 24.5973C28.1324 24.563 28.0437 24.5454 27.9541 24.5455ZM23.0557 5.58725L24.5413 8.18213H18.5986L23.0557 5.58725ZM7.79497 8.18213L19.1945 1.54582C19.5028 1.36538 19.863 1.31744 20.2072 1.40935C20.5555 1.50255 20.8458 1.72761 21.0262 2.04254L21.0276 2.04503L10.4867 8.18213H7.79497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9573 15H23.1846C20.9287 15 19.0938 16.835 19.0938 19.0908C19.0938 21.3467 20.9287 23.1817 23.1846 23.1817H27.9573C29.0852 23.1817 30.0027 22.2642 30.0027 21.1363V17.0454C30.0027 15.9175 29.0852 15 27.9573 15ZM23.1846 20.4544C22.4329 20.4544 21.821 19.8425 21.821 19.0908C21.821 18.3392 22.4329 17.7272 23.1846 17.7272C23.9363 17.7272 24.5482 18.3392 24.5482 19.0908C24.5482 19.8425 23.9363 20.4544 23.1846 20.4544Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_945_942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature72);
export default __webpack_public_path__ + "static/media/feature-7-2.9bae72ee0ab1bd72be9e12d6830d254a.svg";
export { ForwardRef as ReactComponent };